<template>
    <div class="container-fluid">
        <div class="row">
            <div class="col-12">
                <div class="card card-form">
                    <div class="card-body">
                        <div class="row">
                            <div class="col-12 col-md-8 mx-auto">
                                <div class="form-group">
                                    <label>{{$t("reportGeneralDirector.category.income.name")}} <span
                                            class="red">*</span></label>
                                    <input type="text" class="form-control" v-model="companyIncome.name"
                                           :class="{invalid : $v.companyIncome.name.$error}"/>
                                    <div class="red" v-if="$v.companyIncome.name.$error">
                                        {{$t("reportGeneralDirector.category.income.name")}}
                                    </div>
                                </div>
                                <div class="form-group">
                                    <label>{{$t("reportGeneralDirector.category.income.incomeDate")}}</label>
                                    <custom-date-picker
                                            class="form-control"
                                            format="dd/MM/yyyy"
                                            v-model="companyIncome.incomeDate"
                                            :date="companyIncome.incomeDate"
                                            :clear-button="true">
                                    </custom-date-picker>
                                </div>
                                <div class="form-group">
                                    <label>{{$t("reportGeneralDirector.category.income.incomingNumber")}} <span
                                            class="red">*</span></label>
                                    <input type="text" class="form-control" v-model="companyIncome.incomingNumber"
                                           :class="{invalid : $v.companyIncome.incomingNumber.$error}"/>
                                    <div class="red" v-if="$v.companyIncome.incomingNumber.$error">
                                        {{$t("reportGeneralDirector.category.income.incomingNumber")}}
                                    </div>
                                </div>
                                <div class="form-group">
                                    <label>{{$t("reportGeneralDirector.category.income.incomeAmount")}} <span
                                            class="red">*</span></label>
                                    <numeric-input v-model="companyIncome.incomeAmount" :precision="2" required></numeric-input>
                                </div>
                                <div class="form-group">
                                    <label>{{$t("reportGeneralDirector.category.income.description")}}</label>
                                    <textarea type="text" class="form-control" v-model="companyIncome.description"></textarea>
                                </div>
                            </div>
                        </div>
                        <div class="row mt-5">
                            <div class="col-12 btns-box">
                                <button class="all-btn delete-btn" @click="cancel" :disabled="processing">
                                    {{$t("action.cancel")}}
                                </button>
                                <button class="all-btn add-btn" @click="save"
                                        :disabled="processing">
                                    {{$t("action.save")}}
                                </button>

                            </div>
                        </div>

                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import {numericTypes} from '@/shared/constants/mask'
    import initFilterModel from '@/shared/filter';
    import {required/*, requiredUnless, minLength*/} from 'vuelidate/lib/validators';
    import CustomDatePicker from '@/views/common/CustomDatePicker';
    import {formatDate} from '@/shared/utils';

    export default {
        name: "CompanyIncomeAddEditView",
        components: {
            CustomDatePicker
        },
        data() {
            return {
                processing: false,
                loading: {
                    isDocQrLoading: false,
                },
                show: false,
                numericTypes: numericTypes,
                ownerFilter: initFilterModel(),
                employeeFilter: initFilterModel(),
                companyIncome: {
                    id: null,
                    name: null,
                    incomeDate: formatDate(new Date()),
                    incomingNumber: null,
                    incomeAmount: null,
                    description: null
                },
            }
        },
        validations() {
            return {
                companyIncome: {
                    incomeAmount: {
                        required: required
                    },
                    incomingNumber: {
                        required: required
                    },
                    name: {
                        required: required
                    }
                },
            };
        },
        computed: {

        },
        methods: {
            init() {
                const vm = this;
                const id = this.$route.params.id;

                if (id) {
                    this.$http.get('/companyincome/view/' + id)
                        .then(res => {
                            vm.companyIncome = res.data;
                        }, (err) => {
                            console.log(err);
                            vm.loading = false;
                        });
                }
            },
            cancel() {
                this.$router.push('/report-general-director/companyincome');
            },
            save() {
                this.$v.$touch();
                if (this.$v.$invalid) {
                    return;
                }
                this.processing = true;

                this.$http.post('companyincome/save', this.companyIncome)
                    .then(res => {

                        if (res && res.data && res.data.status === 'SUCCESS') {
                            this.$swal({
                                title: this.$t('messages.common.success'),
                                text: this.$t('messages.realEstate.statusSuccess'),
                                type: 'success'
                            });
                            this.$router.push('/report-general-director/companyincome');
                        } else {
                            this.$swal({
                                title: this.$t('messages.common.warning'),
                                text: this.$t('messages.realEstate.statusWarning'),
                                type: 'warning'
                            });
                        }
                        this.processing = false;
                    }, () => {
                        this.$swal({
                            title: this.$t('messages.common.error'),
                            text: this.$t('messages.realEstate.error'),
                            type: 'error'
                        });
                        this.processing = false;
                    });
            },
        },
        created() {
            this.init();
        }
    }
</script>

<style scoped>

</style>
